import { z } from 'zod';
import { connectionStateSchema, ingestModeSchema, postTypeSchema } from '../enums.js';
export const ingestionStatusSchema = z.object({
    mode: ingestModeSchema,
    state: connectionStateSchema,
    /** ISO 8601, last event actually delivered by the source. */
    lastEventAt: z.string().nullable(),
    /** Last time the collector changed state — useful to spot a flapping link. */
    changedAt: z.string(),
    message: z.string().nullable(),
    /** Consecutive failed connection attempts, reset on success. */
    retries: z.number().int(),
});
export const systemStatusSchema = z.object({
    ingestion: ingestionStatusSchema,
    acceptedPostTypes: z.array(postTypeSchema),
    targets: z.object({
        total: z.number().int(),
        active: z.number().int(),
    }),
    posts: z.object({
        total: z.number().int(),
        today: z.number().int(),
        unread: z.number().int(),
        pinned: z.number().int(),
    }),
    serverTime: z.string(),
});
//# sourceMappingURL=system.js.map